'use strict'
// Template version: 1.1.1
// see http://vuejs-templates.github.io/webpack for documentation.

const path = require('path')

module.exports =
{
	appWebsiteUrl: 'https://www.app-maville.com',
	privacyPolicyUrl: 'https://www.app-maville.com/privacy-policy',
	eulaUrl: 'https://www.app-maville.com/eula',
	contactUrl: 'https://www.app-maville.com/contact-us',
	localApiUrl: 'http://127.0.0.1:3330/v1',
	localCdnUrl: 'http://127.0.0.1:5000',
	distApiUrl: 'https://api.app-maville.com/v1',
	distCdnUrl: 'https://static.app-maville.com',
	appRegistryUrl: 'https://appregistry.app-maville.com',
	publicAppBaseUrl: 'https://web.app-maville.com',
	sentryDsn: 'https://28412b0136cc4fe784d8a9bbe14a2d7e@o386543.ingest.sentry.io/5220974',
	analyticsId: 'UA-167400923-1',
	logRocketAppId: 'lbo2zt/ma-ville',

  	dev:
  	{
  		// Paths
  		assetsSubDirectory: 'static',
  		assetsPublicPath: '/',
		proxyTable:
		{
		},
		  
		// Various Dev Server settings
  		host: '0.0.0.0', // can be overwritten by process.env.HOST
  		port: 8080, // can be overwritten by process.env.PORT, if port is in use, a free one will be determined
		autoOpenBrowser: false,
		
		// Show an error overlay over the app in browser on compiler error.
  		errorOverlay: true,
		  
		// Native tooltip when build finished.
  		notifyOnErrors: false,
  		poll: false, // https://webpack.js.org/configuration/dev-server/#devserver-watchoptions-
		  
		// Use Eslint Loader?
  		// If true, your code will be linted during bundling and
  		// linting errors and warnings will be shown in the console.
  		useEslint: true,
		  
		// If true, eslint errors and warnings will also be shown in the error overlay
  		// in the browser.
  		showEslintErrorsInOverlay: true,
		  
		/**
  		 * Source Maps
  		 */
  		// https://webpack.js.org/configuration/devtool/#development
  		devtool: 'eval-source-map',
		  
		// If you have problems debugging vue-files in devtools,
  		// set this to false - it *may* help
  		// https://vue-loader.vuejs.org/en/options.html#cachebusting
  		cacheBusting: false,
		  
		// CSS Sourcemaps off by default because relative paths are "buggy"
  		// with this option, according to the CSS-Loader README
  		// (https://github.com/webpack/css-loader#sourcemaps)
  		// In our experience, they generally work as expected,
  		// just be aware of this issue when enabling this option.
  		cssSourceMap: false,
	},

	build:
	{
  	  	// Template for index.html
  	  	index: path.resolve(__dirname, '../www/index.html'),

  	  	// Paths
  	  	assetsRoot: path.resolve(__dirname, '../www'),
  	  	assetsSubDirectory: 'static',
  	  	assetsPublicPath: '',

  	  	/**
  	  	 * Source Maps
  	  	 */
  	  	productionSourceMap: true,
			
		// https://webpack.js.org/configuration/devtool/#production
  	  	devtool: '#source-map',

  	  	// Gzip off by default as many popular static hosts such as
  	  	// Surge or Netlify already gzip all static assets for you.
  	  	// Before setting to `true`, make sure to:
  	  	// npm install --save-dev compression-webpack-plugin
  	  	productionGzip: false,
  	  	productionGzipExtensions: ['js', 'css'],

  	  	// Run the build command with an extra argument to
  	  	// View the bundle analyzer report after build finishes:
  	  	// `npm run build --report`
  	  	// Set to `true` or `false` to always turn it on or off
  	  	bundleAnalyzerReport: process.env.npm_config_report
  	}
}



//////////////////
// WEBPACK FOOTER
// ./config/index.js
// module id = FhoZ
// module chunks = 1